import React from 'react';
import Modal from './Modal';
import '../css/ErrorModal.css';

const ErrorModal = ({ isOpen, message, onClose, onAction }) => {
  const handleClick = () => {
    if (onAction) {
      onAction();
    }
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onAction ? undefined : onClose}
    >
      <div className="error-modal" data-testid="error-modal">
        <h2>Error</h2>
        <p>{message}</p>
        <button onClick={handleClick} className="error-modal-close-btn" data-testid="close-button">
          {onAction ? 'OK' : 'Close'}
        </button>
      </div>
    </Modal>
  );
};

export default ErrorModal;
